import axios from 'axios'

async function send_test(dispatch,data,token,setOpen,setMessage,setSubmitting,setQuestion,setResponse,setCount,setIsPaused,setDiv){

    setSubmitting(true)
    setIsPaused(true)

    const URL = `${process.env.REACT_APP_SERVER_AUTH_URL}send-test/`

      const sendTest = await axios.post(URL,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

    if (sendTest?.status == 200 && sendTest?.data.success == true) {

      // console.log(sendTest?.data?.question)
      if (sendTest?.data?.hasEnded) {
        setIsPaused(true)
        setDiv(0)
      } else {
        setQuestion(sendTest?.data?.question)
        setIsPaused(false)
        setDiv((data?.test.time*60)/data?.test.questions)
      }
      setResponse("")
      setSubmitting(false)
      setCount((dat) => dat + 1)
    }else{
      setSubmitting(false)
      setIsPaused(true)
      setMessage(sendTest?.data?.message)
      setOpen(true)
    }

}

export default send_test